module.exports = __webpack_public_path__ + "static/media/Logo FDII (1).20fe3821.png";